/* tslint:disable */
/* eslint-disable */
/**
 * Business Orchestration Layer (BOL) API
 * Business Orchestration layer (BOL) API. Public part, exposed to BOL client applications.  Glossary | Definition -- | -- <strong>Logistics Object</strong> | A resource in the BOL system that represents a business entity, such as a QuotationRequest, Quotation, or Service. Logistics Objects are managed through the BOL API and can be accessed or modified by Users based on their permissions i.e. based on their AD Entra ID roles and ACL (Access Control List) modes. <strong>Member</strong> | A data owner in the BOL system, uniquely identified by its `memberIdentifier`. Members are used to manage access control and ownership of Logistics Objects. <strong>User</strong> | A person or entity that interacts with the BOL system, typically through a client application, and beeing authenticated. Users are associated with Members and can perform actions on Logistics Objects based on their access level. User access token includes the Member identifier as part of roles claims. Each path in the API is protected by a custom role defined in AD Entra ID, and operations on Logistics Objects are protected by specific Access modes defined by members. <strong>Access Control</strong> | The mechanism by which the BOL system restricts access to API paths and resources based on the identity of the User and their associated Member. Access control is enforced through AD Entra ID roles and ACL (Access Control List) modes defined for every single Logistics Object. <strong>ACL (Access Control List)</strong> | A set of authorizations that define what actions a User can perform on a Logistics Object. The level of access granted to Users is determined by ACL modes defined in authorizations for specific Logistics Objects. ACL Modes are not directly associated with Users but rather with Members, which are the data owners of Logistics Objects. Each Logistics Object has an ACL that specifies the access modes for different Members. Members need to exist in the BOL system to be granted access to Logistics Objects. <strong>ACL Mode</strong> | The specific level of access control applied to a Logistics Object, determining what actions can be performed by Users. ACL modes are defined for each Logistics Object by `memberIdentifier` and include `READ`, `WRITE`, and `CONTROL`. Each mode includes access granted by the modes under it, so `CONTROL` includes `WRITE` and `READ`, and `WRITE` includes `READ`. <strong>Change Request</strong> | A request to modify a Logistics Object, which is processed by the BOL system. Change requests are created when a User wants to update an existing Logistics Object, and they are subject to approval and application by the system. All changes to Logistics Objects are done through change requests. This allows for a controlled and auditable process of modifications. <strong>Host</strong> | A server alias in the BOL system, used to abstract URI values internally. This allows for flexibility in the underlying infrastructure when migrating or changing server configurations. 
 *
 * The version of the OpenAPI document: 7.2.1-develop.2
 * Contact: benoit.tiers@logist-x.eu
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { LabelAssociation } from './LabelAssociation';
import {
    LabelAssociationFromJSON,
    LabelAssociationFromJSONTyped,
    LabelAssociationToJSON,
    LabelAssociationToJSONTyped,
} from './LabelAssociation';
import type { CompositionMovement } from './CompositionMovement';
import {
    CompositionMovementFromJSON,
    CompositionMovementFromJSONTyped,
    CompositionMovementToJSON,
    CompositionMovementToJSONTyped,
} from './CompositionMovement';
import type { Link } from './Link';
import {
    LinkFromJSON,
    LinkFromJSONTyped,
    LinkToJSON,
    LinkToJSONTyped,
} from './Link';

/**
 * An action describes WHAT needs to be done. The WHERE and the WHEN are specified at the scheduled location or activity level. A requested activity comprises actions in the 'REQUESTED' state, while a planned activity includes both 'SCHEDULED' and 'ACTUAL' actions. The specifics of the actions are defined in subclasses based on the actionType.
 * @export
 * @interface Action
 */
export interface Action {
    /**
     * Requested, planned or actual date and time of the action. UTC timestamp including milliseconds.
     * @type {Date}
     * @memberof Action
     */
    actionDateTime?: Date;
    /**
     * Name given to the action by the owner.
     * @type {string}
     * @memberof Action
     */
    actionName?: string;
    /**
     * Sequence number of the action in the list of the actions to be performed.
     * @type {number}
     * @memberof Action
     */
    sequenceNumber?: number;
    /**
     * Defining if the action is requested, planned or actual.
     * @type {string}
     * @memberof Action
     */
    actionState?: string;
    /**
     * Indicates the type of the action. Action types are derived in subclasses.
     * @type {string}
     * @memberof Action
     */
    actionType?: string;
    /**
     * Indicates the subtype of the action. Action types are derived in subclasses. Subtypes are limited to each type.
     * @type {string}
     * @memberof Action
     */
    actionSubtype?: string;
    /**
     * List of the composition Movements executed during an Handling action.
     * @type {Array<CompositionMovement>}
     * @memberof Action
     */
    compositionMovements?: Array<CompositionMovement>;
    /**
     * id of the seal attached to the container.
     * @type {string}
     * @memberof Action
     */
    sealNumber?: string;
    /**
     * 
     * @type {Link}
     * @memberof Action
     */
    sealedMaterialMean?: Link;
    /**
     * List of links between physical objects and their label
     * @type {Array<LabelAssociation>}
     * @memberof Action
     */
    labelAssociations?: Array<LabelAssociation>;
}

/**
 * Check if a given object implements the Action interface.
 */
export function instanceOfAction(value: object): value is Action {
    return true;
}

export function ActionFromJSON(json: any): Action {
    return ActionFromJSONTyped(json, false);
}

export function ActionFromJSONTyped(json: any, ignoreDiscriminator: boolean): Action {
    if (json == null) {
        return json;
    }
    return {
        
        'actionDateTime': json['actionDateTime'] == null ? undefined : (new Date(json['actionDateTime'])),
        'actionName': json['actionName'] == null ? undefined : json['actionName'],
        'sequenceNumber': json['sequenceNumber'] == null ? undefined : json['sequenceNumber'],
        'actionState': json['actionState'] == null ? undefined : json['actionState'],
        'actionType': json['actionType'] == null ? undefined : json['actionType'],
        'actionSubtype': json['actionSubtype'] == null ? undefined : json['actionSubtype'],
        'compositionMovements': json['compositionMovements'] == null ? undefined : ((json['compositionMovements'] as Array<any>).map(CompositionMovementFromJSON)),
        'sealNumber': json['sealNumber'] == null ? undefined : json['sealNumber'],
        'sealedMaterialMean': json['sealedMaterialMean'] == null ? undefined : LinkFromJSON(json['sealedMaterialMean']),
        'labelAssociations': json['labelAssociations'] == null ? undefined : ((json['labelAssociations'] as Array<any>).map(LabelAssociationFromJSON)),
    };
}

export function ActionToJSON(json: any): Action {
    return ActionToJSONTyped(json, false);
}

export function ActionToJSONTyped(value?: Action | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'actionDateTime': value['actionDateTime'] == null ? value['actionDateTime'] : value['actionDateTime'].toISOString(),
        'actionName': value['actionName'],
        'sequenceNumber': value['sequenceNumber'],
        'actionState': value['actionState'],
        'actionType': value['actionType'],
        'actionSubtype': value['actionSubtype'],
        'compositionMovements': value['compositionMovements'] == null ? undefined : ((value['compositionMovements'] as Array<any>).map(CompositionMovementToJSON)),
        'sealNumber': value['sealNumber'],
        'sealedMaterialMean': LinkToJSON(value['sealedMaterialMean']),
        'labelAssociations': value['labelAssociations'] == null ? undefined : ((value['labelAssociations'] as Array<any>).map(LabelAssociationToJSON)),
    };
}

